module.exports = __webpack_public_path__ + "images/1493a7ba9abfd39bf079c5ac6e3f7a304.svg";